import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IMultiSelectOption } from 'ngx-bootstrap-multiselect';
import { take } from 'rxjs/operators';

import { DocumentDataService } from '../shared/document-data.service';
import { CurrentExportsPanelComponent } from './current-exports-panel/current-exports-panel.component';
import { SharedExportModalComponent } from './shared-export-modal/shared-export-modal.component';
import { UserService } from '@user/user.service';
import { User } from '@user/user.model';

@Component({
  selector: 'oes-global-files',
  templateUrl: './global-files.component.html',
  styleUrls: ['./global-files.component.scss'],
})
export class GlobalFilesComponent implements OnInit {
  @ViewChild(SharedExportModalComponent, { static: false })
  sharedExportModal: SharedExportModalComponent;

  @ViewChild(CurrentExportsPanelComponent, { static: false })
  currentExportsPanel: CurrentExportsPanelComponent;

  activeTab = 'my-files';
  sharingOrgs: IMultiSelectOption[] = [];
  selectedOwnerOrgId: string;
  selectedOwnerOrgName: string;
  loadingOrgs = false;
  loadingDocuments = false;
  currentExportsPanelOpen = false;

  organizationId: string;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _location: Location,
    private _router: Router,
    private _documentDataService: DocumentDataService,
    private _userService: UserService
  ) {}

  ngOnInit() {
    this._userService.getCurrentUser().pipe(take(1)).subscribe((user: User) => {
      if (user) {
        this.organizationId = user.organization.id;
        this.selectTabFromRoute();
      }
    });
  }

  selectTab(tab: string) {
    this.activeTab = tab;
    const urlTree = this._router.createUrlTree([], {
      queryParams: { tab: tab },
      queryParamsHandling: 'merge',
      preserveFragment: true,
    });
    localStorage.setItem('latest-files-tab', tab);
    this._location.go(urlTree.toString());

    if (tab === 'shared-files' && this.sharingOrgs.length === 0) {
      this.loadSharingOrganizations();
    }
  }

  onOrgSelected(orgId: string) {
    this.selectedOwnerOrgId = orgId;
    const selectedOrg = this.sharingOrgs.find(org => org.id === orgId);
    this.selectedOwnerOrgName = selectedOrg?.name || '';
    this.loadingDocuments = true;
  }

  onDocumentsLoaded() {
    this.loadingDocuments = false;
  }

  clearSelectedOrganization() {
    this.selectedOwnerOrgId = '';
    this.selectedOwnerOrgName = '';
    this.loadingDocuments = false;
  }

  openSharedExportModal() {
    this.sharedExportModal?.show();
  }

  toggleCurrentExportsPanel() {
    this.currentExportsPanelOpen = !this.currentExportsPanelOpen;
  }

  closeCurrentExportsPanel() {
    this.currentExportsPanelOpen = false;
  }

  onExportSubmitted() {
    // Refresh the Current Exports panel if it happens to be open, so the new QUEUED row
    // appears without waiting for the next background poll tick.
    this.currentExportsPanel?.refresh();
  }

  private loadSharingOrganizations() {
    if (!this.organizationId) {
      return;
    }
    this.loadingOrgs = true;
    this._documentDataService
      .getSharingOrganizations(this.organizationId)
      .pipe(take(1))
      .subscribe({
        next: (orgs) => {
          this.sharingOrgs = orgs.map(org => ({ id: org.id, name: org.name }));
          this.loadingOrgs = false;
        },
        error: () => {
          this.loadingOrgs = false;
        },
      });
  }

  private selectTabFromRoute() {
    this._activatedRoute.queryParams.pipe(take(1)).subscribe((queryParams) => {
      const latestTab = localStorage.getItem('latest-files-tab');
      this.activeTab = queryParams.tab
        ? queryParams.tab
        : latestTab
        ? latestTab
        : 'my-files';
      this.selectTab(this.activeTab);
    });
  }
}
